<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="الخاتم-العجيب">
<p style="text-align: right;font-family:Sakkal Majalla"><strong><br/>
<br/>
</strong></p>
<h1 style="text-align: center;font-family:Sakkal Majalla"><strong>الإهــــــــــــــــــــــــــــــــــــــــــــــــــــــــــــداء</strong></h1>
<p style="text-align: center;font-family:Sakkal Majalla"><strong>إلى أبنائي الثلاثة:</strong></p>
<p style="text-align: center;font-family:Sakkal Majalla"><strong>أسعد، أسيل، إيناس؛</strong></p>
<p style="text-align: center;font-family:Sakkal Majalla"><strong>الذين ملأوا حياتي حباً وسعادة</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?6acb7c3c